import React from 'react';

export const Spikes3Icon = () => {
  return (
    <svg
      width="43"
      height="18"
      viewBox="0 0 43 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12.5C4 12.2239 4.22386 12 4.5 12H6.5C6.77614 12 7 12.2239 7 12.5V17.5C7 17.7761 6.77614 18 6.5 18H4.5C4.22386 18 4 17.7761 4 17.5V12.5Z"
        fill="#52525C"
      />
      <path
        d="M0 9.5C0 9.22386 0.223858 9 0.5 9H2.5C2.77614 9 3 9.22386 3 9.5V17.5C3 17.7761 2.77614 18 2.5 18H0.5C0.223858 18 0 17.7761 0 17.5V9.5Z"
        fill="#51515C"
      />
      <path
        opacity="0.9"
        d="M8 6.5C8 6.22386 8.22386 6 8.5 6H10.5C10.7761 6 11 6.22386 11 6.5V17.5C11 17.7761 10.7761 18 10.5 18H8.5C8.22386 18 8 17.7761 8 17.5V6.5Z"
        fill="#07ABA1"
      />
      <path
        opacity="0.9"
        d="M20 0.5C20 0.223858 20.2239 0 20.5 0H22.5C22.7761 0 23 0.223858 23 0.5V17.5C23 17.7761 22.7761 18 22.5 18H20.5C20.2239 18 20 17.7761 20 17.5V0.5Z"
        fill="#07ABA1"
      />
      <path
        opacity="0.9"
        d="M28 4.5C28 4.22386 28.2239 4 28.5 4H30.5C30.7761 4 31 4.22386 31 4.5V17.5C31 17.7761 30.7761 18 30.5 18H28.5C28.2239 18 28 17.7761 28 17.5V4.5Z"
        fill="#07ABA1"
      />
      <path
        d="M12 14.5C12 14.2239 12.2239 14 12.5 14H14.5C14.7761 14 15 14.2239 15 14.5V17.5C15 17.7761 14.7761 18 14.5 18H12.5C12.2239 18 12 17.7761 12 17.5V14.5Z"
        fill="#52525C"
      />
      <path
        d="M16 9.5C16 9.22386 16.2239 9 16.5 9H18.5C18.7761 9 19 9.22386 19 9.5V17.5C19 17.7761 18.7761 18 18.5 18H16.5C16.2239 18 16 17.7761 16 17.5V9.5Z"
        fill="#52525C"
      />
      <path
        d="M24 11.5C24 11.2239 24.2239 11 24.5 11H26.5C26.7761 11 27 11.2239 27 11.5V17.5C27 17.7761 26.7761 18 26.5 18H24.5C24.2239 18 24 17.7761 24 17.5V11.5Z"
        fill="#52525C"
      />
      <path
        d="M32 9.5C32 9.22386 32.2239 9 32.5 9H34.5C34.7761 9 35 9.22386 35 9.5V17.5C35 17.7761 34.7761 18 34.5 18H32.5C32.2239 18 32 17.7761 32 17.5V9.5Z"
        fill="#52525C"
      />
      <path
        d="M36 11.5C36 11.2239 36.2239 11 36.5 11H38.5C38.7761 11 39 11.2239 39 11.5V17.5C39 17.7761 38.7761 18 38.5 18H36.5C36.2239 18 36 17.7761 36 17.5V11.5Z"
        fill="#52525C"
      />
      <path
        d="M40 7.5C40 7.22386 40.2239 7 40.5 7H42.5C42.7761 7 43 7.22386 43 7.5V17.5C43 17.7761 42.7761 18 42.5 18H40.5C40.2239 18 40 17.7761 40 17.5V7.5Z"
        fill="#52525C"
      />
    </svg>
  );
};
